import 'core-js/features/array/find';
require('polyfill-array-includes');

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

if (localStorage.getItem('loginLink')) {
  let link = localStorage.getItem('loginLink');
  localStorage.removeItem('loginLink');
  window.location = link;
}

/**
 * Here is the start of the login javascript file. The first part of this is targetting
 * the login button to add a click event. From here we move to the error checking after
 * setting the html of the button to a spinner as well as disabling any further clicks
 * on the button.
 */
$('#loginButton').click(function() {
  $('#loginButton').html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>'
  );
  $('#loginButton').attr('disabled', true);

  $('#loginError').hide();

  setTimeout(function() {
    errorCheckLogin();
  }, 500);
});

$('#forgottenPasswordButton').click(function() {
  $('#loginError').hide();
  $('#forgottenEmailLogin').val($('#emailLogin').val());
});

/**
 * This function checks to see if the email address or password fields are empty
 * before continuing with the rest of the login process.
 */
function errorCheckLogin() {
  let emailVal = $('#emailLogin').val();
  let passwordVal = $('#passwordLogin').val();

  let loginErrorCount = 0;

  if (emailVal == '') {
    loginErrorCount++;
    $('#emailError').html('Email Address missing');
  }

  if (passwordVal == '') {
    loginErrorCount++;
    $('#passwordError').html('Password missing');
  }

  if (loginErrorCount > 0) {
    $('#loginButton').html('Login');
    $('#loginButton').removeAttr('disabled');
  }

  if (loginErrorCount == 0) {
    $('#emailError').html('');
    $('#passwordError').html('');
    continueLogin(emailVal, passwordVal);
  }
}

/**
 * This function uses the firebase auth to sign in the user. If there is no reference
 * to the user in the database authentication then it will alert the user of this.
 * @param  {string} email [This is the user supplied email]
 * @param  {string} pass  [This is the user supplied password]
 */
function continueLogin(email, pass) {
  $('#loginError').hide();
  $('#custEmail').text(email.trim());
  firebase
    .auth()
    .signInWithEmailAndPassword(email, pass)
    .then(_ => window.location.replace('/'))
    .catch(function(err) {
      console.error(err);

      // Check if client exists but needs password reset
      checkIfClientExistsButDoesntHaveALogin(email)
        .catch(_ => checkIfSupplierExistsButNeedsPasswordReset(email))
        .then(_ => {
          $('#databaseUpgradeMessage').show();
          $('#loginButtonRow').hide();
          $('#loginForm').hide();
        })
        .catch(_ => displayLoginError(err));
    });
}

function checkIfClientExistsButDoesntHaveALogin(email) {
  return window.firebaseUtils
    .callFunction('resetClientIfExists', 'POST', { email })
    .then(response => {
      if (response !== 'true') {
        throw new Error('Could not find client with that email address');
      }
      // If the client exists then we need to send them a password reset email
      return firebase.auth().sendPasswordResetEmail(email);
    })
    .catch(err => {
      console.error(err);
      throw err;
    });
}

function checkIfSupplierExistsButNeedsPasswordReset(email) {
  return window.firebaseUtils
    .callFunction('checkIfSupplierNeedsPasswordReset', 'POST', { email })
    .then(response => {
      if (response !== 'true') {
        throw new Error('Could not find supplier with this email address');
      }
      // If the client exists then we need to send them a password reset email
      return firebase.auth().sendPasswordResetEmail(email);
    })
    .catch(err => {
      console.error(err);
      throw err;
    });
}

function displayLoginError(err) {
  $('#loginButton').html('Login');
  $('#loginButton').removeAttr('disabled');

  if (err.code == 'auth/user-not-found' || err.code == 'auth/wrong-password') {
    $('#loginError').text('Incorrect email address or password. Please double check your credentials.');
  } else {
    $('#loginError').text(err.message);
  }
  $('#loginError').show();
}

$('#forgottenPasswordSubmit').click(function() {
  $('#forgottenPasswordSubmit').html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>'
  );
  $('#forgottenPasswordSubmit').attr('disabled', true);

  setTimeout(function() {
    errorCheckForgottenPassword();
  }, 500);
});

function errorCheckForgottenPassword() {
  let emailVal = $('#forgottenEmailLogin').val();

  if (emailVal == '') {
    $('#forgottenEmailError').html('Email Address missing');
    $('#forgottenPasswordSubmit').html('Submit');
    $('#forgottenPasswordSubmit').removeAttr('disabled');
  } else {
    $('#forgottenEmailError').html('');
    continueForgottenPassword(emailVal);
  }
}

function continueForgottenPassword(email) {
  checkIfClientExistsButDoesntHaveALogin(email)
    .catch(_ => checkIfSupplierExistsButNeedsPasswordReset(email))
    .catch(err => console.error(err))
    .then(_ =>
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(function() {
          alert('Request sent, please check your emails');
          $('#forgottenPasswordSubmit').html('Submit');
          $('#forgottenPasswordSubmit').removeAttr('disabled');
          $('#modalForgottenPassword').modal('hide');
        })
    )
    .catch(function(err) {
      $('#forgottenPasswordSubmit').html('Submit');
      $('#forgottenPasswordSubmit').removeAttr('disabled');
      if (err.code == 'auth/user-not-found') {
        alert('Email address not found');
      } else {
        alert(err.message);
      }
    });
}

$(_ => {
  // Confirm the link is a sign-in with email link.
  console.log('Checking for auto-login link...');
  if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
    // Attempt to get email address from current URL
    let email = null;
    try {
      const urlParmsStr = window.location.search.substr(1);
      const urlParmsArr = urlParmsStr.split('&').map(parm => {
        const split = parm.split('=');
        return { key: split[0], value: decodeURIComponent(split[1]) };
      });
      email = urlParmsArr.find(parm => parm.key === 'email').value;
    } catch (err) {
      console.info('Could not detect email address in URL');
    }

    if (!email) {
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again. For example:
      email = window.prompt('Please provide your email for confirmation');
    }

    // Populate on-screen email fields with address we've received
    $('#emailLogin').val(email);
    $('#forgottenEmailLogin').val(email);

    // The client SDK will parse the code from the link for you.
    firebase
      .auth()
      .signInWithEmailLink(email, window.location.href)
      .then(result => {
        // Clear email from storage.
        window.localStorage.removeItem('emailForSignIn');

        // You can access the new user via result.user
        // Additional user info profile not available via:
        // result.additionalUserInfo.profile == null
        // You can check if the user is new or existing:
        // result.additionalUserInfo.isNewUser
        window.location.replace('/');
      })
      .catch(err => {
        console.error(err);
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.

        // Display message
        $('#loginError')
          .show()
          .html(
            `Sorry, that login link has been used. Please log in with your email address and password. <b>If you do not have a password yet</b> please click <b>Forgotten password</b>. You will be sent instructions for creating a password.`
          );

        $('#passwordLogin').focus();
      });
  }
});
